export default {
  data() {
    return {
      message: {
        text: "",
        prop: "",
        type: "base"
      },
      messageIsVisible: false
    };
  },
  methods: {
    showMessage(text = "", prop = "", type = "base") {
      this.messageIsVisible = true;
      this.message.text = text;
      this.message.prop = prop;
      this.message.type = type;
      setTimeout(this.hideMessage, 5000);
    },
    hideMessage() {
      this.messageIsVisible = false;
      this.message = {
        text: "",
        prop: "",
        type: "base"
      };
    }
  }
};
